/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_SoldInputs */

const en_cargos_sold = /** @type {(inputs: Cargos_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold`)
};

const es_cargos_sold = /** @type {(inputs: Cargos_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendidas`)
};

/**
* | output |
* | --- |
* | "Sold" |
*
* @param {Cargos_SoldInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_sold = /** @type {((inputs?: Cargos_SoldInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_SoldInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_sold(inputs)
	return es_cargos_sold(inputs)
});